import { defineMessages } from 'react-intl';

export default defineMessages({
  numPolice: {
    id: 'dashboard_auto.mes_contracts.num_police',
  },
  souscripteur: {
    id: 'mrh_details.my_contracts.souscripteur',
  },
  dateDebut: {
    id: 'mrh_details.my_contracts.date_debut',
  },
  status: {
    id: 'auto_details.my_contracts.status',
  },
  tarifAnnuel: {
    id: 'mrh_details.my_contracts.tarif_annuel',
  },
  primeMensuelle: {
    id: 'mrh_details.my_contracts.prime_mensuelle',
  },
  dateFin: {
    id: 'mrh_details.my_contracts.date_fin',
  },
});
